import styles from './worlds.module.css';

export function WakeProgress({ status }: { status: string }): JSX.Element {
  const label =
    status === 'Waking' ? 'Waking world...' :
    status === 'Provisioning' ? 'Creating world...' :
    'Starting...';

  return (
    <div className={styles.wakeProgress}>
      <div className={styles.wakeBar}>
        <div className={styles.wakePulse} />
      </div>
      <div className={styles.wakeLabel}>{label}</div>
    </div>
  );
}
